const vehicleMappings = {
  P: 'red',
  A: 'blue',
  M: 'green',
  I: 'orange',
  O: 'grey',
  U: 'grey',
  default: 'dark-grey',
}

export default vehicleMappings
